
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hA9EZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $12a53e15b82c3b9f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $90ZcD = parcelRequire("90ZcD");
var $4ceoy = parcelRequire("4ceoy");

var $iHYdz = parcelRequire("iHYdz");

var $ebd3R = parcelRequire("ebd3R");

var $3dGN0 = parcelRequire("3dGN0");

var $3bDjY = parcelRequire("3bDjY");

var $gmhCD = parcelRequire("gmhCD");

var $3ZT8o = parcelRequire("3ZT8o");

var $8RXs9 = parcelRequire("8RXs9");

var $knXBU = parcelRequire("knXBU");

var $1pTqN = parcelRequire("1pTqN");
function $12a53e15b82c3b9f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $12a53e15b82c3b9f$var$titleStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    outline: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $iHYdz.akEditorLineHeight),
    fontWeight: "var(--ds-font-weight-regular, 400)",
    display: 'flex',
    flex: 1,
    margin: 0,
    padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
    textAlign: 'left'
});
const $12a53e15b82c3b9f$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    minHeight: '25px',
    background: "var(--ds-background-neutral-subtle, transparent)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `background 0.3s ${(0, $iHYdz.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $iHYdz.akEditorSwoopCubicBezier)}`,
    padding: "var(--ds-space-0, 0px)",
    paddingBottom: "var(--ds-space-0, 0px)",
    marginTop: "var(--ds-space-050, 0.25rem)",
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'td > :not(style):first-child, td > style:first-child + *': {
        marginTop: 0
    }
});
const $12a53e15b82c3b9f$var$containerStylesExpanded = {
    name: "1ynzp6s",
    styles: "background:var(--ds-surface, rgba(255, 255, 255, 0.6));padding-bottom:var(--ds-space-100, 8px);border-color:var(--ds-border, #091E4224)"
};
const $12a53e15b82c3b9f$var$containerStylesFocused = {
    name: "12e71wc",
    styles: "border-color:var(--ds-border-focused, #388BFF)"
};
const $12a53e15b82c3b9f$var$containerStylesDataNodeTypeExpand = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginLeft: `-${(0, $iHYdz.akLayoutGutterOffset)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginRight: `-${(0, $iHYdz.akLayoutGutterOffset)}px`
});
const $12a53e15b82c3b9f$var$titleContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    alignItems: 'flex-start',
    background: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    width: '100%',
    color: "var(--ds-text-subtle, #44546F)",
    overflow: 'hidden',
    cursor: 'pointer',
    padding: "var(--ds-space-100, 8px)",
    '&:focus': {
        outline: 0
    }
});
const $12a53e15b82c3b9f$var$titleContainerStylesExpanded = {
    name: "dkidh7",
    styles: "padding-bottom:var(--ds-space-0, 0px)"
};
const $12a53e15b82c3b9f$var$contentContainerStyles = {
    name: "288te1",
    styles: "padding-top:var(--ds-space-0, 0px);margin-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-200, 16px);padding-left:var(--ds-space-400, 32px);display:flow-root;visibility:hidden;@supports not (display: flow-root){width:100%;box-sizing:border-box;}"
};
const $12a53e15b82c3b9f$var$contentContainerStylesExpanded = {
    name: "xhzdsf",
    styles: "padding-top:var(--ds-space-100, 8px);visibility:visible"
};
const $12a53e15b82c3b9f$var$contentContainerStylesNotExpanded = {
    name: "1njmbsg",
    styles: ".expand-content-wrapper, .nestedExpand-content-wrapper{width:100%;display:block;height:0;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);user-select:none;}"
};
const $12a53e15b82c3b9f$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $12a53e15b82c3b9f$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $12a53e15b82c3b9f$var$containerStyles,
            props['data-node-type'] === 'expand' && $12a53e15b82c3b9f$var$containerStylesDataNodeTypeExpand,
            props.expanded && $12a53e15b82c3b9f$var$containerStylesExpanded,
            props.focused && $12a53e15b82c3b9f$var$containerStylesFocused
        ],
        ...props
    }, props.children);
};
const $12a53e15b82c3b9f$var$TitleContainer = (props)=>{
    const { expanded: expanded, ...buttonProps } = props;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        type: "button",
        css: [
            $12a53e15b82c3b9f$var$titleContainerStyles,
            expanded && $12a53e15b82c3b9f$var$titleContainerStylesExpanded
        ],
        ...buttonProps
    }, props.children));
};
$12a53e15b82c3b9f$var$TitleContainer.displayName = 'TitleContainerButton';
const $12a53e15b82c3b9f$var$ContentContainer = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $12a53e15b82c3b9f$var$contentContainerStyles,
            props.expanded && $12a53e15b82c3b9f$var$contentContainerStylesExpanded,
            !props.expanded && $12a53e15b82c3b9f$var$contentContainerStylesNotExpanded
        ],
        ...props
    }, props.children);
};
function $12a53e15b82c3b9f$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent) {
    if (!fireAnalyticsEvent) return;
    fireAnalyticsEvent({
        action: (0, $gkwXh.ACTION).TOGGLE_EXPAND,
        actionSubject: nodeType === 'expand' ? (0, $gkwXh.ACTION_SUBJECT).EXPAND : (0, $gkwXh.ACTION_SUBJECT).NESTED_EXPAND,
        attributes: {
            platform: (0, $knXBU.PLATFORM).WEB,
            mode: (0, $knXBU.MODE).RENDERER,
            expanded: !expanded
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    });
}
function $12a53e15b82c3b9f$var$Expand({ title: title, children: children, nodeType: nodeType, intl: intl, fireAnalyticsEvent: fireAnalyticsEvent, nestedHeaderIds: nestedHeaderIds, rendererAppearance: rendererAppearance }) {
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const isMobile = false;
    const label = intl.formatMessage(expanded ? (0, $90ZcD.messages).collapseNode : (0, $90ZcD.messages).expandNode);
    const { current: id } = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))('expand-title-'));
    const handleFocus = (0, $5uXOq.useCallback)(()=>setFocused(true), []);
    const handleBlur = (0, $5uXOq.useCallback)(()=>setFocused(false), []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($12a53e15b82c3b9f$var$Container, {
        "data-testid": `expand-container-${nodeType}-${id}`,
        "data-node-type": nodeType,
        "data-title": title,
        "data-expanded": expanded,
        expanded: expanded,
        focused: focused
    }, nestedHeaderIds && nestedHeaderIds.length > 0 ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1pTqN.ActiveHeaderIdConsumer), {
        nestedHeaderIds: nestedHeaderIds,
        onNestedHeaderIdMatch: ()=>setExpanded(true)
    }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($12a53e15b82c3b9f$var$TitleContainer, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            $12a53e15b82c3b9f$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent);
            setExpanded(!expanded);
            e.persist();
            // @ts-ignore detail doesn't exist on type
            e.detail ? handleBlur() : handleFocus();
        },
        onFocus: handleFocus,
        onBlur: handleBlur,
        "aria-labelledby": id,
        "aria-expanded": expanded,
        contentEditable: false,
        expanded: expanded
    }, isMobile ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $90ZcD.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
        spacing: "spacious"
    })) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: label,
        position: "top",
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        tag: (0, $90ZcD.ExpandLayoutWrapperWithRef),
        testId: 'tooltip'
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $90ZcD.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
        spacing: "spacious"
    }))), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $12a53e15b82c3b9f$var$titleStyles,
        id: id
    }, title || intl.formatMessage((0, $90ZcD.messages).expandDefaultTitle))), /*#__PURE__*/ (0, $f8Sb3.jsx)($12a53e15b82c3b9f$var$ContentContainer, {
        expanded: expanded
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: `${nodeType}-content-wrapper`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $12a53e15b82c3b9f$var$clearNextSiblingMarginTopStyle
    }), (0, $gmhCD.editorExperiment)('confluence_p2m_style_recalc_and_expand_joint_exp', true, {
        exposure: true
    }) ? expanded && children : children))));
}
var $12a53e15b82c3b9f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($12a53e15b82c3b9f$var$Expand);

});
parcelRegister("90ZcD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0b45248d286682ea$export$defe85febe8b728c);
$parcel$export(module.exports, "ExpandIconWrapper", () => $0b45248d286682ea$export$4eeef63d68e77552);
$parcel$export(module.exports, "expandLayoutWrapperStyle", () => $0b45248d286682ea$export$a7ed6bf20867161a);
$parcel$export(module.exports, "ExpandLayoutWrapperWithRef", () => $0b45248d286682ea$export$c67faf67c1185cba);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $7VHMR = parcelRequire("7VHMR");

var $iHYdz = parcelRequire("iHYdz");
function $0b45248d286682ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0b45248d286682ea$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    collapseNode: {
        id: 'fabric.editor.collapseNode',
        defaultMessage: 'Collapse content',
        description: 'Collapse the node'
    },
    expandDefaultTitle: {
        id: 'fabric.editor.expandDefaultTitle',
        defaultMessage: 'Click here to expand...',
        description: 'Placeholder text for an expand node'
    },
    expandNode: {
        id: 'fabric.editor.expandNode',
        defaultMessage: 'Expand content',
        description: 'Expand the node'
    },
    expandPlaceholderText: {
        id: 'fabric.editor.expandPlaceholder',
        defaultMessage: 'Give this expand a title...',
        description: 'Placeholder text for an expand node title input field'
    },
    expandArialabel: {
        id: 'fabric.editor.expandAriaLabel',
        defaultMessage: 'Give this expand a title',
        description: 'aria label for an expand node title input field'
    }
});
const $0b45248d286682ea$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: ()=>expanded ? [
                $0b45248d286682ea$var$expandIconWrapperStyle(),
                $0b45248d286682ea$var$expandIconWrapperExpandedStyle
            ] : $0b45248d286682ea$var$expandIconWrapperStyle()
    }, children);
};
const $0b45248d286682ea$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $f8Sb3.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #44546F)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $iHYdz.akEditorSwoopCubicBezier)}`
        }
    });
const $0b45248d286682ea$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $0b45248d286682ea$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $0b45248d286682ea$export$c67faf67c1185cba = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props, ref)=>{
    const { children: children, ...rest } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0b45248d286682ea$export$a7ed6bf20867161a,
        ...rest,
        ref: ref
    }, children));
});

});

parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});



//# sourceMappingURL=@atlaskit-internal_renderer-node_Expand.352686c6.js.map
